Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Snack", {
  enumerable: true,
  get: function get() {
    return _snack.Snack;
  }
});
var _snack = require("./snack");